<template>
  <v-row dense class="pa-2">
    <v-col cols="12" md="6">
      <v-text-field
        v-model="data.appButtonText"
        label="متن دکمه ورود به اپلیکیشن"
        placeholder="ورود به اپلیکیشن بله"
        outlined
        dense
      />
    </v-col>

    <v-col cols="12" md="6">
      <v-text-field
        v-model="data.webButtonText"
        label="متن دکمه نسخه وب"
        placeholder="مشاهده در نسخه وب بله"
        outlined
        dense
      />
    </v-col>

    <v-col cols="12">
      <v-radio-group v-model="data.desktopAction" row dense>
        <v-radio
          label="نمایش لندینگ اختصاصی در دسکتاپ"
          value="landing"
          color="#00aa55"
        />
        <v-radio
          label="انتقال مستقیم به نسخه تحت وب (web.ble.ir)"
          value="direct_web"
          color="#00aa55"
        />
      </v-radio-group>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "BaleActions",
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>
